module.exports = __webpack_public_path__ + "img/sny03.89b13c40.jpg";